import { render } from "./WordController.vue?vue&type=template&id=1df09e5e"
import script from "./WordController.vue?vue&type=script&lang=js"
export * from "./WordController.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SignSentence/SignSentence/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__